import axios from "axios";
import { currencyJson } from "@/currency";
import { shopConfig } from "@/config/shopConfig";

class ShopifyAPI {
  constructor() {
    this.ShopifyInfo = window;
  }

  /** Open minicart drawer **/
  openDrawer() {
    if (location.pathname == "/cart") return false;
    document.querySelector(".mini_cart_container").classList.add("active");
    document.querySelector(".mini-add-card").classList.add("active");
  }

  /** POST request helper **/
  async postRequest(url, data) {
    try {
      const response = await axios.post(url, data);
      return response;
    } catch (error) {
      return error;
    }
  }

  /** GET request helper **/
  async getRequest(url) {
    let response = await axios
      .get(url)
      .then((res) => res)
      .catch((err) => err);

    if (response.status == 200) return response;

    let errorMessage = response;
    if (response.response) {
      response = response.response;
      if (response.data.error) errorMessage = response.data.error;
      else errorMessage = response.data;
    }
    this.openToast(errorMessage);
    return response;
  }

  /** Get variant stock dynamically **/
  async getVariantStock(variantId) {
    try {
      const res = await fetch(`/variants/${variantId}.js`);
      const data = await res.json();
      return data.inventory_quantity || 0;
    } catch (err) {
      console.warn("⚠️ Failed to fetch variant stock:", err);
      return 0;
    }
  }

  /** Remove item from cart **/
  async removeItem(item = {}) {
    if (Object.keys(item).length == 0) {
      console.log("Opps! something went wrong. Please try again.");
      return;
    }

    const response = await this.postRequest("/cart/change.js", item);

    if (response.status == 200) {
      this.renderHtmlDrawer();
      this.openDrawer();
    } else {
      const errorMessage = response.message;
      this.openToast(errorMessage);
    }

    return response;
  }

  /** Add item to cart **/
  async addItem(item = {}) {
    if (Object.keys(item).length == 0) {
      this.openToast("Opps! something went wrong. Please try again.");
      return;
    }

    let response = await this.postRequest("/cart/add.js", item);

    if (response.status == 200) {
      this.renderHtmlDrawer();
      this.openDrawer();
    } else {
      let errorMessage = response;
      if (response.response) {
        response = response.response;
        errorMessage = response.data.message;
      }
      this.openToast(errorMessage);
    }
  }

  /** Toast popup **/
  openToast(message) {
    const toastDiv = document.querySelector(".common_warning.error .message");
    toastDiv.innerHTML = message;
    const warningDiv = document.querySelector(".error");
    warningDiv.classList.add("active");
    setTimeout(() => {
      toastDiv.innerHTML = "";
      warningDiv.classList.remove("active");
    }, 3000);
  }

  /** Get cart data **/
  async getCart() {
    return await this.getRequest("/cart.js");
  }

  /** Render mini cart drawer **/
  async renderHtmlDrawer() {
    const getCartData = await this.getCart();

    const cartProducts = document.querySelectorAll(".tmbAvailableDataCart");
    const productsArray = [];
    cartProducts.forEach((item) => {
      const mainVariant_data_id = parseInt(item.getAttribute("data-id"));
      const mainProduct_data_stock = parseInt(item.getAttribute("data-stock"));
      productsArray.push({
        id: mainVariant_data_id,
        stock: mainProduct_data_stock,
      });
    });

    const CartItems = getCartData.data.items;
    let card = "";

    for (const item in CartItems) {
      const productHandle = CartItems[item].handle;
      let availableStock = 0;

      try {
        const productInfo = productsArray.find(
          (p) => p.id === CartItems[item].variant_id
        );

        if (productInfo && productInfo.stock > 0) {
          availableStock = productInfo.stock;
        } else {
          // ✅ Live fetch from Shopify
          availableStock = await this.getVariantStock(
            CartItems[item].variant_id
          );
        }
      } catch (err) {
        console.warn("Stock fetch error:", err);
      }

      const isDisabled = availableStock <= CartItems[item].quantity;
      // const isGifted = CartItems[item].discounts.length > 0;

   // Detect free gift / fully discounted product   
const isGifted =
  Number(CartItems[item].final_line_price) === 0 &&
  Number(CartItems[item].original_line_price) > 0 &&
  Number(CartItems[item].line_level_total_discount) > 0;

  console.log("Cart Item:", CartItems[item].product_title, "isGifted:", isGifted);

      // product compare price
      let compareAtPrice = null;
      
      try {
        const productData = await axios.get(`/products/${productHandle}.js`);
        const matchedVariant = productData.data.variants.find(
          (v) => v.id === CartItems[item].variant_id
        );
        if (matchedVariant) compareAtPrice = matchedVariant.compare_at_price;
      } catch (e) {
        console.warn("⚠️ Failed to fetch product details for", productHandle);
      }

      // const actualPrice = CartItems[item].final_price || CartItems[item].price || 0;
      const actualPrice = CartItems[item].final_price ?? CartItems[item].price ?? 0;

      const originalPrice =
        compareAtPrice ||
        CartItems[item].original_price ||
        CartItems[item].price ||
        0;

      let discountPercent = null;
      if (originalPrice > actualPrice) {
        discountPercent = Math.round(
          ((originalPrice - actualPrice) / originalPrice) * 100
        );
      }

      // const showCouponName =
      //   CartItems[item]?.discounts?.length > 0 &&
      //   CartItems[item].discounts[0]?.title;
      // const hasDiscount = originalPrice && originalPrice > actualPrice;

      card += `
      <div class="card mini-cart-card" ${isGifted ? "third-party-free-gift" : ""}" variantID="${CartItems[item].variant_id}">
        <div class="product_img_wrapper" pid="${CartItems[item].product_id}">
          <div class="loader_tmb"><span></span><span></span><span></span><span></span><span></span></div>
          <div>
            <img src="${CartItems[item].image}" loading="lazy" aria-hidden="true" aria-label="Cart Image" width="291" height="291" />
            <button class="body_text remove" variantID="${CartItems[item].variant_id}" aria-label="Remove Item">Remove</button>
          </div>
        </div>

        <a href="${CartItems[item].url}" class="subtitle">${CartItems[item].product_title}</a>

         <div class="cartPrice_wrapper tmb_product_price">
        ${
          originalPrice && originalPrice > actualPrice
            ? `
            <div class="subtitle_b">
                <del>${currencyJson[window?.Shopify?.currency?.active]?.symbol_native}${(
                (originalPrice * CartItems[item].quantity) /
                100
              ).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}</del>
            </div>`
            : ""
        }


        <div class="subtitle_b ${isGifted ? "third-party-free-gift" : ""}">
  ${
    isGifted
      ? "FREE"
      : `${currencyJson[window?.Shopify?.currency?.active]?.symbol_native}${(
          (actualPrice * CartItems[item].quantity) /
          100
        ).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
  }
</div>

        ${
          discountPercent !== null
            ? `
            <span class="discount_tag discount-percentage subtitle_b">${discountPercent}% OFF</span>`
            : ""
        }
    </div>

        <div class="mini_cart-products ${isGifted ? "third-party-free-gift" : ""}">
          <button class="behno_increment_dec miniCart_decre_btn" request="minus" key="${CartItems[item].key}" vid="${CartItems[item].variant_id}" aria-label="Decrement Quantity">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M0 10.4998L21 10.4998" stroke="#656565" stroke-width="1.5"/></svg>
          </button>
          <span>
            <label for="qty-${item}" class="sr-only">Quantity Input</label>
            <input id="qty-${item}" name="number" value="${CartItems[item].quantity}" readonly aria-label="Quantity Input" aria-readonly="true" aria-required="true">
          </span>
          <button class="behno_increment_dec miniCart_incre_btn ${isDisabled ? "disabled" : ""}" request="plus" key="${CartItems[item].key}" vid="${CartItems[item].variant_id}" pid="${CartItems[item].product_id}" aria-label="Increment Quantity">
            <svg width="21" height="21" viewBox="0 0 35 35" fill="none"><path d="M17.7723 0.96283L17.7723 34.5824" stroke="#656565" stroke-width="1.5"/><path d="M0.962891 17.7723L34.5824 17.7723" stroke="#656565" stroke-width="1.5"/></svg>
          </button>
        </div>
      </div>`;
    }

    document.querySelector("#mini_cart_content").innerHTML = card;
    document.querySelector("p.subtotal_price.body_text").innerHTML =
      
      `${new Intl.NumberFormat(shopConfig.locale, {
        style: 'currency',
        currency: shopConfig.currency,
      }).format(getCartData.data.total_price / 100)}`;

    document
      .querySelectorAll(".shopping_btn_count")
      .forEach((e) => (e.innerHTML = getCartData.data.item_count));

    document.querySelector("#afterpay_insert_data").innerHTML = (
      (getCartData.data.total_price / 100).toFixed(2) / 4
    ).toFixed(2);

    if (getCartData.data.item_count == 0) {
      document.querySelector(".mini_cart-payment").style.display = "none";
      document.querySelector(".mini-add-card").style.display = "none";
      document.querySelector(".if_cart_is_empty").style.display = "block";
    } else {
      document.querySelector(".mini_cart-payment").style.display = "block";
      document.querySelector(".mini-add-card").style.display = "block";
      document.querySelector(".if_cart_is_empty").style.display = "none";
    }

    this.refreshRemoveEvent();
    this.increamtDecriment();
  }

  /** Increment / Decrement quantity **/
  increamtDecriment() {
    const classObj = this;
    const btns = document.querySelectorAll(".behno_increment_dec");
    let isUpdating = false;

    for (const button of btns) {
      button.addEventListener("click", async function (event) {
        if (isUpdating) return;
        if (button.classList.contains("disabled")) return;

        isUpdating = true;
        button.classList.add("loading");

        try {
          const targeted = event.target.closest("button");
          const parent = targeted.closest(".mini_cart-products");
          const cardEl = targeted.closest(".card");
          cardEl.classList.add("active");

          const inputField = parent.querySelector("input");
          const currentValue = parseInt(inputField.value) || 0;
          const requestType = targeted.getAttribute("request");
          const key = targeted.getAttribute("key");
          const variantID = targeted.getAttribute("vid");
          const plusBtn = parent.querySelector(".miniCart_incre_btn");

          const productDataEl = document.querySelector(
            `.tmbAvailableDataCart[data-id="${variantID}"]`
          );
          const maxStock = productDataEl
            ? parseInt(productDataEl.getAttribute("data-stock"))
            : await classObj.getVariantStock(variantID);

          let qty = currentValue;

          // Minus
          if (requestType === "minus") {
            if (currentValue === 1) {
              const res = await fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: key, quantity: 0 }),
              });
              if (res.ok) await classObj.renderHtmlDrawer();
              else {
                const data = await res.json().catch(() => ({}));
                classObj.openToast(
                  data.message || "Unable to remove item, please try again."
                );
              }
              return;
            } else qty = currentValue - 1;
          }

          // Plus
          if (requestType === "plus") {
            qty = currentValue + 1;
            if (maxStock && qty > maxStock) {
              classObj.openToast("Maximum available quantity reached.");
              isUpdating = false;
              button.classList.remove("loading");
              return;
            }
          }

          inputField.value = qty;
          plusBtn.classList.toggle("disabled", qty >= maxStock);

          const res = await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: key, quantity: qty }),
          });

          if (res.ok) {
            await classObj.renderHtmlDrawer();
            if (qty >= maxStock) {
              const refreshedBtn = document.querySelector(
                `.miniCart_incre_btn[vid="${variantID}"]`
              );
              if (refreshedBtn) refreshedBtn.classList.add("disabled");
            }
          } else {
            const data = await res.json().catch(() => ({}));
            classObj.openToast(data.message || "Failed to update cart");
          }
        } catch (err) {
          classObj.openToast("Something went wrong, please try again.");
        } finally {
          isUpdating = false;
          button.classList.remove("loading");
        }
      });
    }
  }

  /** Refresh remove button events **/
  async refreshRemoveEvent() {
    const removeBtn = document.querySelectorAll("button.body_text.remove");
    const obj = this;

    for (const button of removeBtn) {
      button.addEventListener("click", async function (event) {
        button.closest(".card").classList.add("active");
        const variantid = event.target.getAttribute("variantid");
        const item = { id: variantid, quantity: 0 };
        obj.removeItem(item);
      });
    }
  }

  refreshMiniCart() {
    this.renderHtmlDrawer();
  }
}

export { ShopifyAPI };
